import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Loader2, ShieldCheck, ArrowLeft } from "lucide-react";

export default function PrivacyPolicyPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancel = false;
    api
      .get("/legal/privacy-policy")
      .then((r) => !cancel && setData(r.data))
      .catch(() => !cancel && setData(null))
      .finally(() => !cancel && setLoading(false));
    return () => {
      cancel = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="privacy-policy-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <Link
          to="/"
          className="inline-flex items-center text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-orange-400 transition mb-8"
          data-testid="privacy-back-home"
        >
          <ArrowLeft size={12} className="mr-1.5" /> Înapoi acasă
        </Link>
        <div className="flex items-center gap-3 mb-4">
          <ShieldCheck size={28} className="text-orange-400" />
          <h1 className="font-outfit font-black text-white text-3xl md:text-4xl tracking-tight">
            Politica de confidențialitate
          </h1>
        </div>
        {loading ? (
          <div className="flex items-center text-zinc-500 text-sm py-12">
            <Loader2 size={14} className="animate-spin mr-2" /> Se încarcă...
          </div>
        ) : !data ? (
          <p className="text-red-400 text-sm">
            Politica nu poate fi încărcată momentan. Reîncearcă în câteva minute.
          </p>
        ) : (
          <>
            <div className="border-l-2 border-orange-500/40 pl-4 mb-8 text-sm text-zinc-400 space-y-1">
              <div>
                <strong className="text-zinc-200">Operator de date:</strong>{" "}
                {data.operator.company_name}
              </div>
              <div>
                <strong className="text-zinc-200">Contact:</strong>{" "}
                <a
                  href={`mailto:${data.operator.contact_email}`}
                  className="text-orange-400 hover:text-orange-300"
                  data-testid="privacy-contact-email"
                >
                  {data.operator.contact_email}
                </a>
              </div>
              <div>
                <strong className="text-zinc-200">Versiune:</strong>{" "}
                {data.version}
              </div>
            </div>
            <article
              className="text-zinc-300 leading-relaxed whitespace-pre-wrap text-sm"
              data-testid="privacy-text"
            >
              {data.text}
            </article>
          </>
        )}
      </main>
    </div>
  );
}
